import axios from "axios";
// Dashboard Data API


function filterData(obj) {
  const result = {};

  for (const key in obj) {
    const value = obj[key];

    // If value is an array (like ECC or pushbutton)
    if(value.type === "pushbutton") {
      const filteredArray = Object.fromEntries(Object.entries(JSON.parse(value.data)).filter(([key, value]) => key.trim() !== ""));
      result[key] = {data: JSON.stringify(filteredArray)};
    } else if(value.type === "camera") {
      const filteredArray = Object.fromEntries(Object.entries(JSON.parse(value.data)).filter(([key, value]) => key.trim() !== ""));
      result[key] = {data: JSON.stringify(filteredArray)};
    } else if (Array.isArray(value)) {
      const filteredArray = value.filter(item => {
        try {
          const parsed = JSON.parse(item.data);
          const innerKey = Object.keys(parsed)[0];
          const name = parsed[innerKey]?.name;

          return name && name.trim() !== ""; // only keep non-empty names
        } catch (err) {
          return false;
        }
      });

      result[key] = filteredArray;
    }

    // If value is an object (JAVA, MQTT, PC etc.)
    else if (typeof value === "object" && value !== null) {
      try {
        const parsed = JSON.parse(value.data);
        const innerKey = Object.keys(parsed)[0];
        const name = parsed[innerKey]?.name;

        if (name && name.trim() !== "") {
          result[key] = value;
        }
      } catch (err) {
        // ignore bad JSON
      }
    }
  }

  return result;
}

export const fetchHealthData = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "HEALTH_STATUS_DATA_REQUEST" });
  try {
    const buildingId = parseInt(new URL(window.location.href).pathname.split('/').pop())
    const url = `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "HEALTH_STATUS_DATA_SUCCESS",
        payload: filterData(response.data),
      });
    }
  } catch {
    dispatch({
      type: "HEALTH_STATUS_DATA_FAILURE",
      payload: "critical",
    });
  }
};

export const fetchJavaData = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "JAVA_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_SERVER_API_URL}/app-status`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "JAVA_DATA_SUCCESS",
        payload: "healthy",
      });
    }
  } catch {
    dispatch({
      type: "JAVA_DATA_FAILURE",
      payload: "critical",
    });
  }
};
// Camera Data Api
export const fetchCameraData = () => async (dispatch) => {
  dispatch({ type: "FETCH_CAMERA_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_SERVER_API_URL}/camera/health`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({
        type: "FETCH_CAMERA_SUCCESS",
        payload: response.data,
      });

      const allHealthy = response.data.every(
        (camera) => camera.status === "Active"
      );
      dispatch({
        type: "SET_CAMERA_STATUS",
        payload: allHealthy ? "healthy" : "critical",
      });
    } else {
      dispatch({
        type: "FETCH_CAMERA_FAIL",
        payload: `Status code: ${response.status}`,
      });
      dispatch({ type: "SET_CAMERA_STATUS", payload: "critical" });
    }
  } catch (error) {
    if (error.response) {
      dispatch({
        type: "FETCH_CAMERA_FAIL",
        payload: `Server error: ${error.response.status} - ${error.message}`,
      });
    } else if (error.request) {
      dispatch({
        type: "FETCH_CAMERA_FAIL",
        payload: "Network error: No response received",
      });
    } else {
      dispatch({
        type: "FETCH_CAMERA_FAIL",
        payload: `Request error: ${error.message}`,
      });
    }

    dispatch({ type: "SET_CAMERA_STATUS", payload: "critical" });
  }
};

export const fetchEccStatus = () => async (dispatch) => {
  dispatch({ type: "FETCH_ECC_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/status/data/all`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = response.data;
    if (data.deviceType === "ecc") {
      const status = data.healthStatus === "Healthy" ? "healthy" : "critical";
      dispatch({
        type: "FETCH_ECC_SUCCESS",
        payload: status,
      });
    } else {
      dispatch({
        type: "FETCH_ECC_FAILURE",
        payload: "critical",
      });
    }
  } catch {
    dispatch({
      type: "FETCH_ECC_FAILURE",
      payload: "critical",
    });
  }
};

export const fetchDetailedViewData = (detailview) => async (dispatch) => {
  dispatch({ type: "FETCH_DETAILED_VIEW_REQUEST" });
  let apis = {};
  const buildingId = parseInt(new URL(window.location.href).pathname.split('/').pop())
  apis = {
      MQTT: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      JAVA: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      "Strobes & Speakers": `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      "Push Button": `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      UPS: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      JACE: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      Camera: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      PepLink: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      Panel: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
      DMP: `${process.env.REACT_APP_API_ALL}/v1/status/data/all/${buildingId}`,
  };
  const url = apis[detailview];
  if (url && detailview !== 0) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        if (detailview === "Strobes & Speakers") {
          const parsed = response.data["ecc"].map(data => JSON.parse(data.data));
          const formatted = parsed.flatMap(obj =>
            Object.values(obj).map(item => ({
              name: item.name,
              health: item.health ? "true" : "false"
            }))
          );
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: formatted,
          });
        } else if(detailview.toLowerCase() === "ups") {
          const key = Object.keys(response.data).find(
            k => k.toLowerCase() === detailview.toLowerCase()
          );

          const { battery_charge, battery_runtime, input_voltage, battery_voltage, operating_mode, load_percent } = JSON.parse(response?.data[key]?.data)[key];
          const formattedData = {
            "Runtime": `${battery_runtime} seconds`,
            "Charge Level": `${battery_charge} %`,
            "Input Voltage": `${input_voltage} v`,
            "Battery Voltage": `${battery_voltage} v`,
            "Operating Mode": operating_mode,
            "Load Percent": `${load_percent} %`,
          };

          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: formattedData,
          });
        } else if(detailview.toLowerCase() === "jace") {
          const key = Object.keys(response.data).find(
            k => k.toLowerCase() === detailview.toLowerCase()
          );
          const { heapsFree, heapsUsed, heapsTotal, cpuLoad, ramUsed, ramFree } = JSON.parse(response?.data[key]?.data)[key];
          const formattedData = {
            "Heaps Free": `${(heapsFree/ (1024 * 1024)).toFixed(2)} MB`,
            "Heaps Used": `${(heapsUsed/ (1024 * 1024)).toFixed(2)} MB`,
            "Heaps Total": `${(heapsTotal/ (1024 * 1024)).toFixed(2)} MB`,
            "CPU Load": `${(cpuLoad/ (1024 * 1024)).toFixed(2)} MB`,
            "Ram Used": `${(ramUsed/ (1024 * 1024)).toFixed(2)} MB`,
            "Ram Free": `${(ramFree/ (1024 * 1024)).toFixed(2)} MB`,
          };

          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: formattedData,
          });
        } else if(detailview.toLowerCase() === "java") {
          const {cpuUsage, freePhysicalMemory, heapMemoryUsed, nonHeapMemoryUsed, totalPhysicalMemory, health} = JSON.parse(response.data.JAVA.data).JAVA

          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: {
              "CPU Usage": cpuUsage,
              "Health": health ? "true" : "false",
              "Free Physical Memory": `${(freePhysicalMemory / (1024 * 1024)).toFixed(2)} MB` ,
              "Heap Memory": `${(heapMemoryUsed / (1024 * 1024)).toFixed(2)} MB`,
              "Non Heap Memory": `${(nonHeapMemoryUsed / (1024 * 1024)).toFixed(2)} MB`,
              "Total Physical memory": `${(totalPhysicalMemory / (1024 * 1024)).toFixed(2)} MB`,
            },
          });
        } else if(detailview.toLowerCase() === "camera") {
          let cameraDetailedData = Object.keys(JSON.parse(response.data.camera.data)).map((cameraname) => cameraname !== "status" ? JSON.parse(response.data.camera.data)[cameraname] : '');
          cameraDetailedData = cameraDetailedData.filter((data) => data  !== "");
          cameraDetailedData = cameraDetailedData.map((camreas) => ({
            "streamUrl": camreas.streamUrl,
            "macAddress": camreas.macAddress,
            "unixTime": camreas.unixTime,
            "name": camreas.name,
            "deviceMake": camreas.deviceMake,
            "ipAddress": camreas.ipAddress,
            "health": camreas.health ? "true" : "false",
            "topic": camreas.topic,
            "topicName": camreas.topicName,
            "dateInstalled": camreas.dateInstalled,
            "status": camreas.status,
            "statusCode": camreas.statusCode
          }))
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: cameraDetailedData,
          });
        } else if(detailview.toLowerCase() === "mqtt") {
          const mqttData = {
              "name": JSON.parse(response.data.MQTT.data).MQTT.name,
              "health": JSON.parse(response.data.MQTT.data).MQTT.health ? "true" : "false",
              "topic": JSON.parse(response.data.MQTT.data).MQTT.topic,
              "node": JSON.parse(response.data.MQTT.data).MQTT.node,
              "version": JSON.parse(response.data.MQTT.data).MQTT.version,
              "otp_release": JSON.parse(response.data.MQTT.data).MQTT.otp_release,
              "load1": JSON.parse(response.data.MQTT.data).MQTT.load1,
              "uptime": JSON.parse(response.data.MQTT.data).MQTT.uptime,
              "role": JSON.parse(response.data.MQTT.data).MQTT.role,
              "memory_used": JSON.parse(response.data.MQTT.data).MQTT.memory_used,
              "memory_total": JSON.parse(response.data.MQTT.data).MQTT.memory_total,
              "node_status": JSON.parse(response.data.MQTT.data).MQTT.node_status,
              "edition": JSON.parse(response.data.MQTT.data).MQTT.edition,
              "max_fds": JSON.parse(response.data.MQTT.data).MQTT.max_fds,
              "connections": JSON.parse(response.data.MQTT.data).MQTT.connections,
              "load15": JSON.parse(response.data.MQTT.data).MQTT.load15,
              "load5": JSON.parse(response.data.MQTT.data).MQTT.load5,
              "cluster_sessions": JSON.parse(response.data.MQTT.data).MQTT.cluster_sessions,
              "live_connections": JSON.parse(response.data.MQTT.data).MQTT.live_connections,
              "log_path": JSON.parse(response.data.MQTT.data).MQTT.log_path,
              "process_available": JSON.parse(response.data.MQTT.data).MQTT.process_available,
              "process_used": JSON.parse(response.data.MQTT.data).MQTT.process_used,
              "sys_path": JSON.parse(response.data.MQTT.data).MQTT.sys_path
          }
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: mqttData,
          });
        } else if(detailview.toLowerCase() === "panel") {
          const  { humidity, temperature } = JSON.parse(response.data.PANEL.data).PANEL;
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: {
                    "Humidity": `${humidity} %`,
                    "Temperature": `${temperature} °C`,
                  }});
        } else if(detailview.toLowerCase() === "dmp") {
          const parsed = response.data["DMP"].map(data => JSON.parse(data.data));

          const formatted = parsed.flatMap(obj =>
            Object.values(obj).map(item => ({
              name: item.name,
              health: item.health ? "true" : "false"
            }))
          );
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: formatted,
          });
        } else if(detailview.toLowerCase() === "peplink") {
          const parsed = response.data["peplink"].map(data => JSON.parse(data.data));

          const formatted = parsed.flatMap(obj =>
            Object.values(obj).map(item => ({
              name: item.name,
              health: item.health ? "true" : "false"
            }))
          );
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: formatted,
          });
        } else if(detailview.toLowerCase() === "push button") {
          const parsed = JSON.parse(filterData(response.data).pushbutton.data);
          const { status, ...rest } = parsed;
          // const keys = Object.keys(rest);
          // const values = Object.values(rest);
          const result = Object.values(rest).map(({ name, health }) => ({ name, health }));
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: result,
          });
        }
          else { 
          dispatch({
            type: "FETCH_DETAILED_VIEW_SUCCESS",
            payload: response.data,
          });
        }
      } else {
        dispatch({
          type: "FETCH_DETAILED_VIEW_FAILURE",
          payload: `Unexpected status code: ${response.status}`,
        });
      }
    } catch (error) {
      dispatch({
        type: "FETCH_DETAILED_VIEW_FAILURE",
        payload: error.message,
      });
    }
  }
};
// Clear Function
export const clearDetailedViewAc = () => ({
  type: "CLEAR_DETAILED_VIEW",
});